module.exports = __webpack_public_path__ + "img/vr.fc4db886.png";